import registerPerformanceObserver from '../register-performance-observer';

const RECORD_TYPE = 'layout-shift';

/**
 * Track cumulative layout shift. (https://web.dev/cls/)
 * Totals all of the layout shifts that occur while the current tab is in focus.
 * Calls the callback and resets the total when the tab loses focus.
 */
const cumulativeLayoutShiftObserver = (
  callback: (cumulativeLayoutShift: number) => void
) => {
  let cls = 0;

  const onObservation = (list: PerformanceObserverEntryList) => {
    for (const entry of list.getEntries()) {
      // @ts-ignore for `entry.hadRecentInput`
      if (!entry.hadRecentInput) {
        // @ts-ignore for `entry.value`
        cls += entry.value;
      }
    }
  };

  const onDisconnect = () => {
    callback(cls);
  };

  return registerPerformanceObserver(RECORD_TYPE, onObservation, onDisconnect);
};

export default cumulativeLayoutShiftObserver;
